<script>
import Vue from 'vue'
import UtilDateTime from '@/utils/UtilDateTime';
import UtilObject from '@/utils/UtilObject';
import UtilNumber from '@/utils/UtilNumber';
import ItensREService from '@/api/v2/services/ItensREService';

export default {

    //==================================================================//
    //=========================-=== NAME ===============================//
    //==================================================================//
    name: 'CreateListEmbView',
    
    //==================================================================//
    //============================ PROPS ===============================//
    //==================================================================//
    props: [
        "usuarioStore",
        "colaboradorStore",
        "gerarListaDeEmbarque", 
        "dadosSelecionados",
        "itemCodigosCaldeiraria",
        "controlesDesativados",
    ],

    //==================================================================//
    //============================ DATA ================================//
    //==================================================================//
    data(){

        return {

            //==================================================================//
            //======================= Mosta Modal ==============================//
            //==================================================================//
            mostraModal: false,

            //==================================================================//
            //============================ Dado ================================//
            //==================================================================//
            dado: {},

            //==================================================================//
            //========================= Prepara Dado ===========================//
            //==================================================================//
            job: null,

            expanded: [],
            selected: [],

            selectedItemCompleted: [],

            listEmb: {
                pesoLiquido: 0,
                pesoBruto: 0,
                reponsavel: '',
                observacao: '',
                cliente: '',
            },

            //==================================================================//
            //=========================== TABELA ===============================//
            //==================================================================//
            dadoHeaders: [
                { text: 'Sequência',                    value: 'sequencia' },
                { text: 'Número',                       value: 'item.codigo' },
                { text: 'Descrição',                    value: 'descricao' },
                { text: 'Quantidade Disponível',        value: 'quantidadeParaEmbarcar' },
                { text: 'Quantidade Embarcando',        value: 'quantidadeEmbarcando' },
                // { text: 'Embarcar item por completo',   value: 'embarcarCompletamente', width: 200 },
            ],

            //==================================================================//
            //=========================== TABELA ===============================//
            //==================================================================//
            subItemsCaldeiraria: []

        }

    },

    //==================================================================//
    //=========================== Methods ==============================//
    //==================================================================//
    methods: {

        //==================================================================//
        //======================= Prepara o Modal ==========================//
        //==================================================================//
        async alteraControlesDesativados(update){

            this.$emit('alteraControlesDesativados',update);

        },

        //==================================================================//
        //======================= Prepara o Modal ==========================//
        //==================================================================//
        async preparaModal(){

            await this.preparaDado();
            this.abreModal();

        },

        //==================================================================//
        //======================== Abre o Modal ============================//
        //==================================================================//
        abreModal(){

            this.mostraModal = true;

        },

        //==================================================================//
        //======================== Fecha o Modal ===========================//
        //==================================================================//
        fechaModal(){

            this.mostraModal = false;
            this.$emit('fechaGerarListaDeEmbarque');

        },

        //==================================================================//
        //========================= Prepara Dado ===========================//
        //==================================================================//
        async preparaDado(){

            let itens = this.dadosSelecionados.map((dado)=>{

                let job = {
                    id: dado?.job?.id || "",
                    codigo: dado?.job?.code || "",
                    descricao: dado?.job?.description || "",
                };

                let cliente = {
                    id: dado?.job?.cliente?.id || "",
                    codigo: dado?.job?.cliente?.codigo || "",
                    nome: dado?.job?.cliente?.nomeFantasia || "",
                };

                let fornecedor = {
                    id: dado?.fornecedor?.id || "",
                    codigo: dado?.fornecedor?.codigo || "",
                    nome: dado?.fornecedor?.nome || "",
                }

                let ordemDeServico = {
                    id: dado?.ordemDeServico?.id || "",
                    codigo: dado?.ordemDeServico?.codigo || "",
                    descricao: dado?.ordemDeServico?.descricao || "",
                };

                let responsavel = {
                    id: this?.colaboradorStore?.colaborador?.id || "",
                    nome: this?.colaboradorStore?.colaborador?.nome || "",
                };

                let item = {
                    id: dado?.item?.id || "",
                    codigo: dado?.item?.code || "",
                    descricao: dado?.item?.description || "",
                };

                let unidade = {
                    id: dado?.unidade || "",
                    descricao: dado?.unidadeSigla || "",
                };

                return {
                    id: dado?.id || "",
                    sequencia: dado?.sequencia || "",
                    status: dado?.status || "",
                    destino: dado?.destino || "",
                    descricao: dado?.descricao || "",
                    quantidadeParaEmbarcar: dado?.quantidadeParaEmbarcar || 0,
                    quantidadeEmbarcando: dado?.quantidadeParaEmbarcar || 0,
                    // embarcarCompletamente: false,
                    job: job || {},
                    cliente: cliente || {},
                    fornecedor: fornecedor || {},
                    ordemDeServico: ordemDeServico || {},
                    item: item || {},
                    unidade: unidade || {},
                    responsavel: responsavel || {},
                };

            });

            let itemAUX = UtilObject.clone(itens[0]);

            let job = itemAUX?.job || {};
            let cliente = itemAUX?.cliente || {};
            let fornecedor = itemAUX?.fornecedor || {};
            let favorecido = itemAUX?.cliente || itemAUX?.fornecedor || {};
            let ordemDeServico = itemAUX?.ordemDeServico || {};
            let responsavel = itemAUX?.responsavel || {};

            this.dado = {
                job: job || {},
                cliente: cliente || {},
                fornecedor: fornecedor || {},
                favorecido: favorecido || {},
                ordemDeServico: ordemDeServico || {},
                responsavel: responsavel || {},
                destino: itemAUX.destino || "",
                dataCriacao: UtilDateTime.todayUTC() || "",
                dataCriacaoFormatada: UtilDateTime.todayBrazil() || "",
                observacao: "",
                pesoLiquido: 0,
                pesoBruto: 0,
                itens: itens || [],
            }
            
        },

        //==================================================================//
        //================= Validar Quantidade Embarcando ==================//
        //==================================================================//
        validarQuantidadeEmbarcando(item){

            let quantidadeEmbarcando = UtilNumber.toNumber(item?.quantidadeEmbarcando);

            if(quantidadeEmbarcando <= 0){

                this.$notfy.error("Quantidade Embarcando é menor ou igual a Zero.");
                item.quantidadeEmbarcando = item.quantidadeParaEmbarcar;

                return;

            }

            if(quantidadeEmbarcando > item?.quantidadeParaEmbarcar){

                this.$notfy.error("Quantidade Embarcando é maior que a Disponivel.");
                item.quantidadeEmbarcando = item.quantidadeParaEmbarcar;

                return;

            }

        },

        //==================================================================//
        //====================== Valida Peso Liquido =======================//
        //==================================================================//
        validaPesoLiquido(){

            let pesoLiquido = UtilNumber.toNumber(this.dado.pesoLiquido);

            if(pesoLiquido <= 0) {
                
                this.$notfy.error("Peso Liquido menor ou igual a Zero.");
                this.dado.pesoLiquido = 0;

                return;

            }

        },

        //==================================================================//
        //====================== Validar Peso Bruto ========================//
        //==================================================================//
        validaPesoBruto(){

            let pesoBruto = UtilNumber.toNumber(this.dado.pesoBruto);

            if(pesoBruto <= 0) {

                this.$notfy.error("Peso Bruto menor ou igual a Zero.");
                this.dado.pesoBruto = 0;

                return;

            }

        },

        //==================================================================//
        //================ Gera Lista de Embarque de Cliente ===============//
        //==================================================================//
        async geraListaDeEmbarqueCliente(){

            this.alteraControlesDesativados(true);

            let itens = this.dado.itens.map((item)=>{

                return{
                    ordemDeServicoItem: item?.id || "",
                    descricao: item?.descricao || "",
                    quantidadeEmbarcando: item?.quantidadeEmbarcando || 0,
                    unidade: item?.unidade?.id || "",
                }

            });

            let listaDeEmbarqueValores = {
                job: this?.dado?.job?.id || "",
                ordemDeServico: this?.dado?.ordemDeServico?.id || "",
                cliente: this?.dado?.cliente?.id || "",
                responsavel: this?.dado?.responsavel?.id || "",
                itens: itens || [],
                observacao: this?.dado?.observacao || "",
            };
        
            let listaDeEmbarque = await ItensREService.gerarListaDeEmbarqueDeCliente(listaDeEmbarqueValores);
            if(listaDeEmbarque.status != 200){
                throw new Error("Falha ao Gerar Lista de Embarque.");
            }

            this.alteraControlesDesativados(false);

            this.fechaModal();

        },

        //==================================================================//
        //==================== Ao Gerar Lista de Embarque ==================//
        //==================================================================//

        async geraListaDeEmbarqueDeFornecedor(){

            let itens = this.dado.itens.map((item)=>{

                return{
                    ordemDeServicoItem: item?.id || "",
                    descricao: item?.descricao || "",
                    quantidadeEmbarcando: item?.quantidadeEmbarcando || 0,
                    unidade: item?.unidade?.id || "",
                }

            });

            let listaDeEmbarqueValores = {
                job: this?.dado?.job?.id || "",
                ordemDeServico: this?.dado?.ordemDeServico?.id || "",
                fornecedor: this?.dado?.fornecedor?.id || "",
                itens: itens,
            };
        
            console.log(listaDeEmbarqueValores);

            let ordemDeServicoItens = await ItensREService.gerarListaDeEmbarqueDeFornecedor(listaDeEmbarqueValores);
            if(ordemDeServicoItens.status != 200){
                throw new Error("Falha ao Gerar Lista de Embarque.");
            }

            this.fechaModal();

        },

        //==================================================================//
        //==================== Ao Gerar Lista de Embarque ==================//
        //==================================================================//

        async aoGerarListaDeEmbarque(){

            if(this.dado.destino == "Cliente"){

                this.geraListaDeEmbarqueCliente();
                return
            }

            if(this.dado.destino == "Fornecedor"){

                this.geraListaDeEmbarqueDeFornecedor();
                return
            }

        },

    },

    watch: {

        async gerarListaDeEmbarque(){

            if(this.gerarListaDeEmbarque == true){

                this.preparaModal();

            }

        },

    },

}
</script>

<template>

    <v-dialog 
        class="custom-dialog"
        v-model="mostraModal" 
        width="100%" 
        style="margin: 100px !important;" 
        persistent 
    >

        <v-card>

            <v-card-title>

                <span class="text-h5"> Criar Lista de Embarque</span>

            </v-card-title>

            <div style="padding: 20px">

                <v-row 
                    no-gutters 
                    style="gap: 15px;"
                >
                    
                    <v-text-field 
                        class="pt-5 pb-5"
                        :value="dado?.job?.codigo" 
                        type="text"
                        label="Job"
                        chips 
                        clearable 
                        hide-details 
                        hide-selected 
                        outlined 
                        disabled>
                    </v-text-field>

                    <v-text-field
                        class="pt-5 pb-5" 
                        :value="dado?.ordemDeServico?.codigo"
                        type="text"
                        label="Ordem de Serviço" 
                        chips 
                        clearable 
                        hide-details 
                        outlined 
                        disabled
                    ></v-text-field>

                    <v-text-field 
                        class="pt-5 pb-5"
                        :value="colaboradorStore?.colaborador?.nome"
                        type="text"
                        label="Responsavel"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        outlined
                        disabled
                    ></v-text-field>

                </v-row>

                <v-row 
                    no-gutters 
                    style="gap: 15px;"
                >
                    
                    <v-text-field 
                        class="pt-5 pb-5"
                        :value="dado?.destino"
                        type="text"
                        label="Destino"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        outlined
                        disabled>
                    </v-text-field>

                    <v-text-field 
                        class="pt-5 pb-5"
                        :value="dado?.favorecido?.nome"
                        type="text"
                        label="Favorecido"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        outlined
                        disabled>
                    </v-text-field>

                </v-row>

                <v-row 
                    no-gutters 
                    style="gap: 15px;"
                >

                    <v-text-field
                        class="pt-5 pb-5"
                        :value="dado?.dataCriacaoFormatada"
                        type="text"
                        label="Data da Lista de Embarque"
                        chips
                        hide-details
                        hide-selected
                        outlined
                        disabled
                    ></v-text-field>

                    <v-text-field
                        class="pt-5 pb-5"
                        v-model.number="dado.pesoLiquido"
                        type="number"
                        label="Peso Liquido"
                        :disabled="controlesDesativados"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        outlined
                        @blur="validaPesoLiquido"
                    ></v-text-field>

                    <v-text-field
                        class="pt-5 pb-5"
                        v-model.number="dado.pesoBruto"
                        type="number"
                        label="Peso Bruto"
                        :disabled="controlesDesativados"
                        chips
                        hide-details
                        hide-selected
                        outlined
                        @blur="validaPesoBruto"
                    ></v-text-field>

                </v-row>

                <v-textarea
                    class="pt-5 pb-5"
                    v-model="dado.observacao"
                    type="text"
                    label="Observação"
                    :disabled="controlesDesativados"
                    chips
                    clearable
                    hide-details
                    hide-selected
                    outlined
                ></v-textarea>

                <!-- 
                    show-expand 
                    :expanded.sync="expanded"
                 -->
                <v-data-table 
                    :headers="dadoHeaders" 
                    :items="dado.itens" 
                    item-value="id" 
                    
                    disable-sort
                    hide-default-footer 
                >

                    <template v-slot:item.quantidadeEmbarcando ="{ item }">

                        <v-text-field
                            v-model.number="item.quantidadeEmbarcando"
                            type="number"
                            dense
                            :disabled="controlesDesativados"
                            @blur="validarQuantidadeEmbarcando(item)"
                            :min="0"
                        ></v-text-field>

                    </template>

                    <!-- <template v-slot:item.embarcarCompletamente="{ item }">

                        <v-checkbox
                            v-model="item.embarcarCompletamente"
                            @click.stop
                        ></v-checkbox>

                    </template> -->

                    <!-- <template v-slot:expanded-item="{ item }">

                        <td 
                            style="padding: 35px;"
                            :colspan="10"
                        >

                            <v-simple-table dense>

                                <template v-slot:default>

                                    <thead>

                                        <tr>
                                            <td></td>
                                            <th>Sequencia</th>
                                            <th>Subitem</th>
                                            <th>Quantidade Disponivel</th>
                                            <th>Quantidade para Embarcar</th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr v-for="(sub, sIndex) in getSubItems(item)" :key="sIndex">

                                            <td>

                                                <v-checkbox
                                                    :disabled="item.completedItem"
                                                    v-model="selected"
                                                    :value="sub.id"
                                                    @click.stop
                                                ></v-checkbox>

                                            </td>

                                            <td>
                                                {{ sub.seq }}
                                            </td>

                                            <td>{{ sub.description }}</td>

                                            <td>
                                                {{ sub?.qtd || 0 }}
                                            </td>

                                            <td>
                                                <v-text-field 
                                                    :disabled="!selected.includes(sub.id)"
                                                    v-model="sub.qtdEntregue"
                                                    type="number"
                                                    dense
                                                    :min="0"
                                                />
                                            </td>

                                        </tr>

                                    </tbody>

                                </template>

                            </v-simple-table>

                        </td>

                    </template> -->

                </v-data-table>

            </div>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn 
                    color="blue darken-1" 
                    text 
                    :disabled="controlesDesativados"
                    @click="fechaModal"
                >
                    Cancelar
                </v-btn>

                <v-btn
                    color="blue darken-1"
                    text
                    :disabled="controlesDesativados"
                    @click="aoGerarListaDeEmbarque"
                >
                    Confirmar
                </v-btn>

            </v-card-actions>

        </v-card>

    </v-dialog>

</template>